import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  combineLatest, filter, map, take
} from 'rxjs';
import {
  selectAppStateHasHydrated,
  selectAppStateIsAuthenticated
} from '../../shared/provider/app-state-provider/state/state.selectors';

export const authGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return combineLatest([
    store.select(selectAppStateHasHydrated),
    store.select(selectAppStateIsAuthenticated),
  ]).pipe(
    filter(([hasHydrated]) => hasHydrated),
    take(1),
    map(([, isAuthenticated]) => {
      if (isAuthenticated) {
        return true;
      }

      return router.createUrlTree(['/login']);
    })
  );
};
